import React, { useState } from "react";
import api from "../api/api";
import { getPracticeId } from "../config/practice";
import { UnlockGlyph } from "./userui";
import { PasswordDialog } from "./PasswordFields";
import "./user.css";

/* Unlock, from a Locked status pill: asks first, then PUT /user/{id}/status,
   which clears the lock and the failed sign-in count. */
const UnlockUserModal = ({ user, onClose, onUnlocked }) => {
  const practiseid = getPracticeId();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const name = `${user?.firstname || ""} ${user?.lastname || ""}`.trim() || user?.username;
  const sub = [user?.username, user?.email].filter(Boolean).join(" · ");

  const unlock = async () => {
    if (busy) return;
    setBusy(true);
    setError("");
    try {
      const response = await api.put(`/v1/${practiseid}/user/${user.id}/status`, {
        practiceid: practiseid,
        rowid: user.id,
        status: "A",
      });
      if (response?.status === 200) {
        onUnlocked();
        onClose();
        return;
      }
      setError(response?.message || "The user wasn't unlocked. Please try again.");
    } catch (e) {
      console.error(e);
      setError("The user wasn't unlocked. Please try again.");
    }
    setBusy(false);
  };

  return (
    <PasswordDialog
      icon={UnlockGlyph}
      title={`Unlock ${name}?`}
      sub={sub}
      onClose={onClose}
      footer={
        <>
          <button type="button" className="bmuf-cancel" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="bmuf-save" onClick={unlock} disabled={busy}>
            {busy ? "Unlocking…" : "Unlock"}
          </button>
        </>
      }
    >
      {error && <p className="bmuf-err">{error}</p>}
      <p className="bmpw-note">
        This account was locked after too many failed sign-in attempts. Unlocking lets them sign in again with
        their current password and resets the failed attempt count.
      </p>
    </PasswordDialog>
  );
};

export default UnlockUserModal;
